import React from 'react';

export default function TrustSafetyPolicy() {
  return (
    <div className="bg-white min-h-screen py-12 px-4">
      <div className="max-w-5xl mx-auto space-y-10 text-gray-800">

        {/* Header */}
        <div className="text-center space-y-4">
          <h1 className="text-4xl font-extrabold text-purple-600">
            Trust & Safety Policy
          </h1>
          <p className="text-lg text-gray-700 text-center">
            Million2Trillion (M2T) actively protects every verified user through multiple layers of trust, safety, and platform-wide security enforcement.
          </p>
        </div>

        {/* Trust & Safety Content */}
        <div className="bg-white border border-purple-200 rounded-2xl shadow p-8 space-y-8 text-base">

          <div>
            <h2 className="text-2xl font-bold text-purple-500 mb-3">Core Trust Layers</h2>
            <ul className="list-disc space-y-2 pl-6">
              <li> Verified identity onboarding (KYC)</li>
              <li> AML (Anti-Money Laundering) monitoring</li>
              <li> Skill & experience validation for all professional roles</li>
              <li> Sanctions list cross-referencing</li>
              <li> Jurisdictional compliance filtering</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-purple-500 mb-3">Ongoing Platform Safety Enforcement</h2>
            <ul className="list-disc space-y-2 pl-6">
              <li> Continuous account monitoring for behavioral violations</li>
              <li> Transaction review to prevent fraud, scams, or money laundering</li>
              <li> Strict audit of any signal providers, educators, or advisory services</li>
              <li> Mandatory disclosure of affiliations, partnerships, or commissions</li>
              <li> Platform authority to suspend or terminate any member violating trust or compliance terms</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-purple-500 mb-3">Zero Tolerance Zones</h2>
            <ul className="list-disc space-y-2 pl-6">
              <li> Fake credentials or identity manipulation</li>
              <li> Insider trading, market manipulation, or trading violations</li>
              <li> Multi-level marketing or pyramid schemes</li>
              <li> Selling unlicensed financial advisory services</li>
              <li> Misrepresentation of investment returns or performance claims</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-purple-500 mb-3">Dispute & Investigation Process</h2>
            <ul className="list-disc space-y-2 pl-6">
              <li> Members may report suspicious activities or violations directly to M2T safety teams</li>
              <li> All reports are investigated confidentially</li>
              <li> Sanctions may include warnings, suspensions, bans, or permanent blacklist status depending on violation severity</li>
              <li> Repeated or criminal violations will be reported to applicable regulatory authorities</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-purple-500 mb-3">Trust is Mandatory To Operate on M2T</h2>
            <p>
              All participants, including traders, educators, developers, coders, influencers, media partners, brokers, and signal providers must operate with full honesty, transparency, and professional conduct.
            </p>
          </div>

        </div>


      </div>
    </div>
  );
}
